// @ts-nocheck
import React, { ReactElement } from 'react'
import useFeatureFlags from 'hooks/useFeatureFlags'
import {
  Resident,
  ConsentFormTemplate,
  CreateConsentFormsJSON,
  ConsentType
} from '@lmc/common/types'

// Import both versions
import ConsentFormNew from './ConsentFormNew'
import ConsentFormLegacy from './ConsentFormLegacy'

type ConsentFormModalProps = {
  fetchResidentConsentForms: (resident: string) => void
  isModalConsentVisible: boolean
  item: string
  category: string
  resident: Resident
  setIsModalConsentVisible: (e: boolean) => void
  templates: ConsentFormTemplate[]
  sendConsentForms: (forms: CreateConsentFormsJSON) => Promise<any>
  closeMainModal: () => void
  consentType: ConsentType
  testId?: string
}

const ConsentFormModalWrapper = (
  props: ConsentFormModalProps
): ReactElement => {
  const featureFlags = useFeatureFlags({ flagNames: ['informed_consent'] }).data
  const isInformedConsentEnabled =
    featureFlags['informed_consent']?.enabled || false

  // Return the appropriate version based on feature flag
  if (isInformedConsentEnabled) {
    return <ConsentFormNew {...props} />
  }

  return <ConsentFormLegacy {...props} />
}

export default ConsentFormModalWrapper
